import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import { Dialog, DialogContent } from "@sorcery/ui";
import { useEffect } from "react";
import { CardGalleryModal } from "../modals/CardGalleryModal";
import { ContentModal } from "../modals/ContentModal";

export const Modal = () => {
  const { isModalOpen, closeModal, modalType, props } = useModal();
  const modalResolver = () => {
    switch (modalType) {
      case ModalTypeEnum.CARDGALLERY:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <CardGalleryModal index={props!.index!} cards={props!.cards!} />;
      case ModalTypeEnum.CONTENT:
        return <ContentModal>{props?.children}</ContentModal>;
      default:
        return null;
    }
  };

  useEffect(() => {
    // hide page scrollbar when modal open
    if (isModalOpen) {
      // biome-ignore lint/style/noRestrictedGlobals: <explanation>
      document.documentElement.style.overflow = "hidden";
    } else {
      // biome-ignore lint/style/noRestrictedGlobals: <explanation>
      document.documentElement.style.overflow = "";
    }
    return () => {
      // biome-ignore lint/style/noRestrictedGlobals: <explanation>
      document.documentElement.style.overflow = "";
    };
  }, [isModalOpen]);

  return (
    <Dialog open={isModalOpen} onOpenChange={(v) => !v && closeModal()}>
      <DialogContent gallery>{modalResolver()}</DialogContent>
    </Dialog>
  );
};
